import React, { useContext } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import steps from "./ComponentMap";
import "./style.css";
import NotFound from "./NotFound";
import {
  getCountries,
  getMetadata,
  getEnvKeys,
} from "../../Services/metadataService";
import Loader from "../Loader/Loader";
import TokenGate from "../TokenGate";
import { useGtmPageview } from "../../analytics/useGtmPageview.tsx";
import { AppContext } from "../../contexts/AppContext.jsx";

export default function Intro() {
  useGtmPageview();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [validated, setValidated] = React.useState(false);
  const stepKeys = Object.keys(steps);
  const applyPath = stepKeys[1];
  const renewIdentityPath = stepKeys[2];
  const publicRoutes = new Set([
    "/app/session-expiry",
    "/app/session-timeout",
    "/app/something-went-wrong",
    "/app/something-went-wrong-upgrade",
    "/app/attempts-exhausted",
  ]);
  const skipAuthGate = publicRoutes.has(location.pathname);
  const { appState } = useContext(AppContext);
  const applicationNumber = appState?.requestPayload?.applicationId;


  const getTitle = () => {
    const isFirstStep =
      location.pathname === applyPath ||
      location.pathname === renewIdentityPath;
    const isLastStep = location.pathname?.includes("application-submit");

    if (isFirstStep) {
      return "Start application";
    }
    if (isLastStep) {
      return "Application complete";
    }
    return "Application in progress";
  };

  // Called after TokenGate confirms token is valid
  const handleAuthValidated = () => {
    setError("");
    getCountries();
    getMetadata();
    getEnvKeys();
    setLoading(false);
    setValidated(true);
  };

  const handleNext = (next) => {
    if (!next) {
      next = "/app/";
    }
    const stepKeys = Object.keys(steps);

    const nextIndex = stepKeys.indexOf(next);
    const nextStep = stepKeys[nextIndex];
    navigate(nextStep);
  };

  const handleBack = (nextNo) => {
    if (!nextNo) navigate(-1);
    else {
      const stepKeys = Object.keys(steps);
      const nextIndex = stepKeys.indexOf(nextNo);
      const nextStep = stepKeys[nextIndex];
      navigate(nextStep);
    }
  };

  if (!skipAuthGate && !validated) {
    return <TokenGate onValidated={handleAuthValidated} />;
  }

  if (!skipAuthGate && error) {
    return <div className="error-message">{error}</div>;
  }
  if (!skipAuthGate && loading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      <Routes>
        {Object.entries(steps).map(
          ([
            path,
            {
              progress,
              showApplication,
              statusText,
              showProgress,
              component: Component,
              element,
              nextYes,
              nextNo,
              back,
            },
          ]) => (
            <Route
              key={path}
              path={path}
              element={
                element ? (
                  element
                ) : (
                  <React.Fragment>
                    {showProgress && applicationNumber && (
                      <div className="application-number">
                        Application number:{" "}
                        <span className="emp">{applicationNumber}</span>
                      </div>
                    )}
                    <Component
                      handleNext={() => handleNext(nextYes)}
                      handleBack={() => handleBack(nextNo)}
                      handleCancel={() => handleNext(back)}
                    />
                  </React.Fragment>
                )
              }
            />
          ),
        )}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  );
}
